import {
  EnvironmentProviders,
  ErrorHandler,
  makeEnvironmentProviders,
} from '@angular/core';
import { BASE_URL_PROVIDER } from '@imagise/shared';
import { provideBrowserErrorListeners } from './browser-error.listeners';
import {
  ErrorReportingConfig,
  ERROR_REPORT_PROMPTER,
  ERROR_REPORTING_CONFIG,
} from './error-reporting.config';
import { provideErrorReportingI18n } from './error-reporting.i18n';
import { GlobalErrorHandler } from './global-error.handler';
import { ErrorReportOverlayService } from './ui/error-report-overlay/error-report-overlay.service';

/**
 * Single entry point to enable error reporting in an app. Registers the config,
 * the global {@link ErrorHandler}, and (unless disabled) the browser error
 * listeners.
 *
 * @example
 * provideErrorReporting({
 *   appName: 'imagise-app',
 *   appVersion: environment.version,
 *   isProduction: environment.isProduction,
 *   errorRoutePath: 'error',
 * })
 */
export function provideErrorReporting(
  config: ErrorReportingConfig
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ERROR_REPORTING_CONFIG, useValue: config },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: ERROR_REPORT_PROMPTER, useExisting: ErrorReportOverlayService },
    provideErrorReportingI18n(),
    ...(config.baseUrl
      ? [{ provide: BASE_URL_PROVIDER, useValue: config.baseUrl }]
      : []),
    ...(config.enableBrowserListeners === false
      ? []
      : [provideBrowserErrorListeners()]),
  ]);
}
